import { IsOptional, Length, Max, Min } from 'class-validator';

import { AuctionTypeEnum } from '@onArte/shared/enums/common';

export class AuctionCreateOnWebsiteModel {
  @Length(32, 36)
  public itemId: string;

  @Length(6, 32)
  public type: AuctionTypeEnum;

  @IsOptional()
  @Min(1)
  @Max(1000000)
  public startPrice?: number;

  @IsOptional()
  @Min(1)
  @Max(1000000)
  public acceptablePrice?: number;

  constructor(
    itemId: string,
    type: AuctionTypeEnum,
    acceptablePrice?: number
  ) {
    this.itemId = itemId;
    this.type = type;
    this.acceptablePrice = acceptablePrice;
  }
}
